import React from "react";
import classnames from "classnames";
import { StyledButton } from "./styled";
import { MinusSquareOutlined, PlusSquareOutlined } from "@ant-design/icons";

const ExpandIconButton = ({
  expand,
  onClick,
}: {
  expand: boolean;
  onClick: () => void;
}) => (
  <StyledButton
    className={classnames({ expand })}
    icon={expand ? <MinusSquareOutlined /> : <PlusSquareOutlined />}
    size="small"
    shape="circle"
    onClick={onClick}
  />
);

export default ExpandIconButton;
